import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/Button';
import siteContent from '../../data/site-content.json';

export function Hero() {
  const navigate = useNavigate();

  const handleStartConverting = () => {
    navigate('/app');
  };

  const handleViewDemo = () => {
    // Scroll to features section or navigate to app
    const featuresSection = document.getElementById('features');
    if (featuresSection) {
      featuresSection.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/app');
    }
  };

  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-primary-50 via-white to-secondary-50 dark:from-gray-900 dark:via-gray-900 dark:to-gray-800">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="text-center lg:text-left">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 dark:text-white leading-tight mb-6">
              <span className="bg-gradient-to-r from-primary-600 via-secondary-600 to-accent-600 bg-clip-text text-transparent">
                {siteContent.hero.headline}
              </span>
            </h1>
            
            <p className="text-xl text-gray-600 dark:text-gray-300 mb-8 max-w-2xl">
              {siteContent.hero.subheadline}
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Button 
                size="lg" 
                rightIcon={<ArrowRight className="w-5 h-5" />}
                onClick={handleStartConverting}
                className="flex-grow"
              >
                {siteContent.hero.ctaPrimary}
              </Button>
            </div>

            {/* Trust Indicators */}
            <div className="mt-12">
              <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">
                Trusted by professionals worldwide
              </p>
              <div className="flex items-center justify-center lg:justify-start space-x-8 opacity-60">
                <div className="text-2xl font-bold text-gray-400">FOREX</div>
                <div className="text-2xl font-bold text-gray-400">RATES</div>
                <div className="text-2xl font-bold text-gray-400">API</div>
              </div>
            </div>
          </div>

          {/* Visual/Demo */}
          <div className="relative">
            <div className="bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl shadow-2xl p-6 border border-gray-200/50 dark:border-gray-700/50">
              <div className="space-y-4">
                <div className="flex items-center justify-between">
                  <h3 className="font-semibold text-gray-900 dark:text-white">Quick Convert</h3>
                  <div className="flex space-x-1">
                    <div className="w-3 h-3 bg-red-400 rounded-full"></div>
                    <div className="w-3 h-3 bg-yellow-400 rounded-full"></div>
                    <div className="w-3 h-3 bg-green-400 rounded-full"></div>
                  </div>
                </div>
                
                <div className="space-y-3">
                  <div className="flex items-center space-x-3 p-3 bg-gray-50 dark:bg-gray-700/50 rounded-lg">
                    <span className="text-2xl">🇺🇸</span>
                    <div className="flex-1">
                      <div className="text-sm text-gray-500 dark:text-gray-400">USD</div>
                      <div className="font-mono text-lg">1,000.00</div>
                    </div>
                  </div>
                  
                  <div className="flex items-center space-x-3 p-3 bg-primary-50 dark:bg-primary-900/20 rounded-lg border border-primary-200 dark:border-primary-800">
                    <span className="text-2xl">🇪🇺</span>
                    <div className="flex-1">
                      <div className="text-sm text-gray-500 dark:text-gray-400">EUR</div>
                      <div className="font-mono text-lg">920.50</div>
                    </div>
                  </div>
                  
                  <div className="flex items-center space-x-3 p-3 bg-gray-50 dark:bg-gray-700/50 rounded-lg">
                    <span className="text-2xl">🇬🇧</span>
                    <div className="flex-1">
                      <div className="text-sm text-gray-500 dark:text-gray-400">GBP</div>
                      <div className="font-mono text-lg">790.25</div>
                    </div>
                  </div>
                </div>
                
                <div className="text-xs text-gray-500 dark:text-gray-400 text-center">
                  Live rates • Updated 2 min ago
                </div>
              </div>
            </div>

            <div className="absolute -bottom-4 -left-4 w-16 h-16 bg-gradient-to-br from-secondary-400 to-secondary-600 rounded-full flex items-center justify-center text-white shadow-lg">
              <span className="text-2xl">⚡</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}